/* KBM PDP Restructure - reorders product page per Kevin's spec, responsive
   v40: Bulk pricing placement is now rendered SERVER-SIDE in sections/kbm-product-page.liquid
        (inside .product-gallery on desktop, CSS-ordered last on mobile). The JS relocation that
        caused layout shift has been removed. This file now only handles the remaining
        right-column reordering and wholesale copy cleanup.
   Wholesale CTA gets "Sourcing for production?" stripped and 100 yd → 50 yard.
*/
(function(){
  if (!document.body.classList.contains('template-product')) return;
  if (/\/products\/kbmfabrics-swatches/i.test(location.pathname)) return;

  function restructure(){
    /* 1. Description → Spec Sheet */
    var description = document.querySelector('.product-description');
    var spec = document.querySelector('.kbm-spec-sheet');

    if (description && description.textContent.trim()) {
      if (!spec) {
        spec = document.createElement('div');
        spec.className = 'kbm-spec-sheet kbm-spec-sheet--from-desc';
        spec.innerHTML = '<h3 class="kbm-spec-sheet__title">About this fabric</h3>';
        description.parentNode.insertBefore(spec, description);
      }
      if (!spec.contains(description)) {
        var specTitle = spec.querySelector('.kbm-spec-sheet__title');
        description.classList.remove('product-description');
        description.classList.add('kbm-spec-sheet__description');
        if (specTitle && specTitle.nextSibling) {
          spec.insertBefore(description, specTitle.nextSibling);
        } else if (specTitle) {
          spec.appendChild(description);
        } else {
          spec.insertBefore(description, spec.firstChild);
        }
        description.style.background = 'transparent';
        description.style.border = 'none';
        description.style.borderLeft = 'none';
        description.style.padding = '0';
        description.style.margin = '0 0 14px';
        description.style.borderRadius = '0';
      }
    }

    /* 2. Clean wholesale CTA text */
    var wholesale = document.querySelector('div[style*="#fef0ee"][style*="#B04440"]');
    if (wholesale) {
      var html = wholesale.innerHTML;
      html = html.replace(/<strong\b[^>]*>\s*Sourcing for production\?\s*<\/strong>\s*/i, '');
      html = html.replace(/100\s*yd\s*minimum/gi, '50 yard minimum');
      html = html.replace(/100\s*yard\s*minimum/gi, '50 yard minimum');
      html = html.replace(/\b50\s*yd\b/gi, '50 yard');
      html = html.replace(/^\s*[—\-]\s*/, '');
      wholesale.innerHTML = html;
    }

    /* 3. Reorder right column: delivery, spec, wholesale after .kbm-express-checkout */
    var express = document.querySelector('.kbm-express-checkout');
    if (express && express.parentNode) {
      var parent = express.parentNode;
      var delivery = document.querySelector('.kbm-delivery-est');
      var afterExpress = express.nextSibling;
      if (wholesale) parent.insertBefore(wholesale, afterExpress);
      if (spec) parent.insertBefore(spec, parent.contains(wholesale) ? wholesale : afterExpress);
      if (delivery) parent.insertBefore(delivery, parent.contains(spec) ? spec : (parent.contains(wholesale) ? wholesale : afterExpress));
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restructure);
  else setTimeout(restructure, 30);

  document.addEventListener('shopify:section:load', function(){ setTimeout(restructure, 50); });
})();
